import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const getPicklist = (
  fieldName= '',
  objectFieldList = [],
  exception= []
) => {
  if(!Array.isArray(objectFieldList)) return []
  const fieldInformation =  objectFieldList.filter((o) => o.name === fieldName)

  if (fieldInformation.length === 0) {
    return []
  }

  const options = fieldInformation[0].picklistValues
    .filter((o) => o.active === true)
    .filter((x) => !exception.includes(x.value))
    .map((pickList) => pickList.label)

  return options
}

export const splitDateTime = (dateTimeString, type) => {
  if (!dateTimeString || typeof dateTimeString !== 'string') {
    return null;
  }

  const date = dayjs(dateTimeString).tz('Asia/Singapore', true);

  if (!date.isValid()) {
    return null; 
  }

  const localDate = date.format('YYYY-MM-DD');
  const localTime = date.format('HH:mm:ss'); 

  if (type === 'date') {
    return localDate; 
  } else if (type === 'time') {
    return localTime; 
  }

  return null;
};

export const mergeDateTime = (date, time, label) => {
  if (!date) {
    if (!time) {
      return null;
    }
    throw new Error(`Please Complete your ${label}!`);
  }
  console.log(time,'hello')
  const timeToUse = time || '00:00';
  const dateTimeString = `${date}T${timeToUse}`;
  const localDateTime = dayjs(dateTimeString).local();
  const formattedDateTime = localDateTime.format('YYYY-MM-DDTHH:mm:ss.SSSZ');

  return formattedDateTime;
};

export function isDifferentValue(formData, mainData) {
  return Object.keys(formData).some((key) => {
    const normalize = (value) => (value === null || value === "" ? null : value);

    return !(key in mainData) || normalize(formData[key]) !== normalize(mainData[key]);
  });
}